/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { bool, func, node, number, oneOfType, string } from 'prop-types';

import { N50 } from '@assets/colors';
import { noop } from '@ajaibid/utils';
import styles from './style';

const Button = (props) => {
  const {
    text,
    size,
    children,
    color,
    textColor,
    borderColor,
    hoverColor,
    textHoverColor,
    disabled,
    disableColor,
    width,
    height,
    onClick,
  } = props;

  const [hover, setHover] = useState(false);

  const buttonStyles = { ...styles.button };
  const buttonStylesDisabled = { ...styles.disabled };

  if (color) {
    buttonStyles.backgroundColor = color;
  }
  if (textColor) {
    buttonStyles.color = textColor;
  }
  if (borderColor) {
    buttonStyles.border = `solid 1px ${borderColor}`;
  }

  if (width) {
    buttonStyles.width = width;
    buttonStylesDisabled.width = width;
  }
  if (size) {
    buttonStyles.fontSize = size;
    buttonStylesDisabled.fontSize = size;
  }
  if (height) {
    buttonStyles.height = height;
    buttonStylesDisabled.height = height;
  }

  const buttonStylesHover = { ...buttonStyles };

  if (hoverColor) {
    buttonStylesHover.backgroundColor = hoverColor;
  }
  if (textHoverColor) {
    buttonStylesHover.color = textHoverColor;
  }
  if (disabled) {
    buttonStylesDisabled.backgroundColor = disableColor;
  }

  const getButtonStyle = () => {
    if (!disabled) {
      if (hover) {
        return {
          ...buttonStyles,
          backgroundColor: hoverColor || N50,
        };
      }
      return { ...buttonStyles };
    }
    return buttonStylesDisable;
  };

  return (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      type="button"
      style={getButtonStyle()}
      onClick={onClick}
      disabled={disabled}
    >
      {text || children}
    </button>
  );
};

Button.propTypes = {
  text: string,
  color: string,
  textColor: string,
  onClick: func,
  hoverColor: string,
  textHoverColor: string,
  children: oneOfType([node, string]),
  borderColor: string,
  width: oneOfType([number, string]),
  height: oneOfType([number, string]),
  size: oneOfType([number, string]),
  disabled: bool,
  disableColor: string,
};

Button.defaultProps = {
  text: '',
  color: '',
  textColor: '',
  onClick: noop,
  hoverColor: '',
  textHoverColor: '',
  children: null,
  borderColor: '',
  width: '',
  height: '',
  size: '',
  disabled: false,
  disableColor: '',
};

export default Button;
